import { all, spawn } from 'redux-saga/effects'
import { keepAlive } from './SagaUtils'

import { AppSagas } from './AppSagas'
import { StartupSagas } from './StartupSagas'
import { LoginSagas } from 'Sagas/LoginSagas'
import { NavigationSagas } from 'Sagas/NavigationSagas'
import { ManageSubscriptionSagas } from 'Sagas/ManageSubscriptionSagas'
import { PaymentSagas } from 'Sagas/PaymentSagas'
import { WellhubSagas } from 'Sagas'
import { UscSagas } from 'Sagas/UscSagas'
// import { RemoteConfigSagas } from 'Sagas/RemoteConfigSagas'

// Some word of caution here
// https://reactrouter.com/web/guides/deep-redux-integration
// Integrating redux with react-router is not oficially supported and discouraged, and it is easy to see why
// keeping the navigation state in your own app state breaks separation of concerns
// as such unless there is a major reason to do so I'm keeping the
// navigation state and the app state separate, if your sagas need to navigate
// you need to pass the `history` object to the saga via the action itself
// it is a bit verbose but should prevent abusing the router

// Each saga is wrapped in keepAlive (see SagaUtils): without it, one uncaught
// throw cancels the entire saga tree and the app silently stops reacting.
export function * rootSaga() {
  yield all([
    spawn(keepAlive, AppSagas, 'AppSagas'),
    spawn(keepAlive, StartupSagas, 'StartupSagas'),
    spawn(keepAlive, LoginSagas, 'LoginSagas'),
    spawn(keepAlive, NavigationSagas, 'NavigationSagas'),
    spawn(keepAlive, ManageSubscriptionSagas, 'ManageSubscriptionSagas'),
    spawn(keepAlive, PaymentSagas, 'PaymentSagas'),
    spawn(keepAlive, WellhubSagas, 'WellhubSagas'),
    spawn(keepAlive, UscSagas, 'UscSagas')
    // spawn(keepAlive, RemoteConfigSagas, 'RemoteConfigSagas')
  ])
}
